import React from 'react';

import { Autocomplete, CircularProgress, TextField, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useDebouncedCallback } from 'use-debounce';

import { InputWrapper } from './InputWrapper';
import { AddButton } from 'components/Button';

//  THE PROPERTY optionLabelName IS REQUIRED AS THE AUTOCOMPLETE COMPONENT
//  REQUIRES IT'S ITEM OBJECT TO HAVE THE LABEL PROPERTY AS AN

//  !!! UNIQUE !!!

//  IDENTIFIER. IT (optionLabelName) MAPPS SOME EXISTING PROPERTY OF THE ITEM OBJECT
//  TO THE LABEL

export const CardAutocomplete = ({
  name = '',
  label = '',
  fullWidth = false,
  wrapperSx = {},
  onChange,
  ItemCard,
  handleNotFoundButtonClick = () => null,
  queryFunction,
  optionLabelName, //
  companyType = "Supplier",
  skipCreatingShadow = false,
  value = null,
  valueChangable = true,
  changeSelectedValueOnChange = false,
  fetchOnOpen = false,
  loadingInitial = false,
  placeholder = 'Please enter a search parameter',
}) => {
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(loadingInitial);
  const [selectedValue, setSelectedValue] = useState(value); 
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const { data, refetch } = useQuery([name, inputValue], () => queryFunction(inputValue), {
    enabled: (fetchOnOpen && open) || (!!inputValue && valueChangable),
    initialData: { data: [] },
    select: ({ data }) => {
      return data.map((item) => ({
        ...item,
        label:
          typeof item[optionLabelName] === 'number'
            ? item[optionLabelName].toString()
            : item[optionLabelName],
      }));
    },
    onSettled: () => {
      setLoading(() => false);
    },
  });

  const debouncedSetInputValue = useDebouncedCallback(
    (newInputValue) => setInputValue(() => newInputValue),
    300
  );
  useEffect(() => {
    if (inputValue) refetch();
    // eslint-disable-next-line
  }, [inputValue]);

  return (
    <InputWrapper fullWidth={fullWidth} wrapperSx={wrapperSx} label={label}>
      <Autocomplete
        disabled={!valueChangable}
        fullWidth={true}
        // name={name}
        value={selectedValue}
        blurOnSelect={true}
        options={data}
        getOptionLabel={(item) => item.label}
        filterOptions={(x) => x}
        onChange={(event, newValue) => {
          event.preventDefault();
          if (changeSelectedValueOnChange) {
            setSelectedValue(newValue);
          }
          onChange && onChange(newValue);
        }}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onInputChange={(_, newInputValue) => {
          if (!valueChangable) return;
          setLoading(() => !!newInputValue);
          debouncedSetInputValue(newInputValue);
        }}
        noOptionsText={
          loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <CircularProgress color="primary" size={20} />
            </Box>
          ) : inputValue ? (
            skipCreatingShadow ? (
              'Nothing found'
            ) : (
              <AddButton fullWidth onClick={handleNotFoundButtonClick}>
                Create Shadow {companyType}
              </AddButton>
            )
          ) : (
            'Start typing to search'
          )
        }
        renderOption={(props, option) => <ItemCard {...{ ...props, ...option }} />}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password',
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && inputValue && <CircularProgress color="primary" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            sx={{
              // '*': { fontWeight: 'bold !important' },
              '.MuiInputBase-root': { backgroundColor: 'white', py:0 },
            }}
            placeholder={placeholder}
          />
        )}
        ListboxProps={{
          sx: {
            p: 0,
            boxShadow: 25,
            borderWidth: 2,
            maxHeight: 300,
            '& > *': {
              p: '16px !important',
              bgcolor: 'white !important',
            },
            '& > *:hover': { bgcolor: 'white !important' },
            '& > :not(:last-child)': {
              borderBottom: '2px solid',
              borderColor: 'border.main',
            },
          },
        }}
      />
    </InputWrapper>
  );
};
